var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"md":"4"}},[_c('div',[_c('h5',{staticClass:"font-weight-bold mb-0 text-left red--text text-center mb-4"},[_vm._v(" CONSEJO MEXICANO DE PATOLOGÍA CLÍNICA Y MEDICINA DE LABORATORIO, A. C. ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }